import { render, staticRenderFns } from "./chooseContactDialog.vue?vue&type=template&id=dba9b72a"
import script from "./chooseContactDialog.vue?vue&type=script&lang=js"
export * from "./chooseContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports